import React from "react";
import AttachmentBrowser from "./attachment_browser";
import OptionsMenu from "./options_menu";

import "./styles/adobe_plugin";

export default class Plugin extends React.Component {
    state = {
        selected_brandfolder: null,
        menu_open: true
    };

    selectBrandfolder = brandfolder => {
        this.setState({ selected_brandfolder: brandfolder });
        this.toggleMenu();
    };

    toggleMenu = () => {
        this.setState({ menu_open: !this.state.menu_open });
    };

    renderPlugin() {
        if (!this.state.menu_open) {
            return (
                <AttachmentBrowser
                    jwt={this.props.jwt}
                    selected_brandfolder={this.state.selected_brandfolder}
                    toggleMenu={this.toggleMenu}
                />
            );
        } else {
            return (
                <OptionsMenu
                    jwt={this.props.jwt}
                    selected_brandfolder={this.state.selected_brandfolder}
                    adobe_application={this.props.adobe_application}
                    selectBrandfolder={this.selectBrandfolder}
                    toggleMenu={this.toggleMenu}
                />
            );
        }
    }

    render() {
        return <div className='adobe-plugin-component'>{ this.renderPlugin() }</div>
    }
}
